import React from 'react';
import { useLocation } from 'react-router-dom';

const bgMap = {
  '/app': '/bg/bg_dashboard_1782905830348.jpg',
  '/app/guests': '/bg/bg_guests_1782905837869.jpg',
  '/app/tables': '/bg/bg_tables_1782905845798.jpg',
  '/app/timeline': '/bg/bg_timeline_1782905856264.jpg',
  '/app/budget': '/bg/bg_budget_1782905864081.jpg',
  'default': '/bg/bg_dashboard_1782905830348.jpg',
};

export default function CeremindBackground() {
  const location = useLocation();
  
  let currentBg = bgMap['default'];
  
  if (location.pathname === '/app') {
    currentBg = bgMap['/app'];
  } else if (
    location.pathname.startsWith('/app/guests') || 
    location.pathname.startsWith('/app/guest-messages') || 
    location.pathname.startsWith('/app/rsvp')
  ) {
    currentBg = bgMap['/app/guests'];
  } else if (location.pathname.startsWith('/app/tables')) {
    currentBg = bgMap['/app/tables'];
  } else if (
    location.pathname.startsWith('/app/timeline') || 
    location.pathname.startsWith('/app/calendar') || 
    location.pathname.startsWith('/app/moments') || 
    location.pathname.startsWith('/app/tasks')
  ) {
    currentBg = bgMap['/app/timeline'];
  } else if (
    location.pathname.startsWith('/app/budget') || 
    location.pathname.startsWith('/app/vendors') || 
    location.pathname.startsWith('/app/settings') || 
    location.pathname.startsWith('/app/documents') || 
    location.pathname.startsWith('/app/chat') || 
    location.pathname.startsWith('/app/invitations')
  ) {
    currentBg = bgMap['/app/budget'];
  }

  // Get unique backgrounds
  const uniqueBgs = Object.values(bgMap).filter((v, i, a) => a.indexOf(v) === i);

  return (
    <div className="fixed inset-0 z-[-1] pointer-events-none bg-[#FAF9F6]">
      {uniqueBgs.map((bgUrl) => (
        <img 
          key={bgUrl}
          alt="" 
          className={`absolute inset-0 w-full h-full object-cover filter blur-[6px] transition-opacity duration-1000 ease-in-out ${currentBg === bgUrl ? 'opacity-40' : 'opacity-0'}`} 
          src={bgUrl}
        />
      ))}
      <div className="absolute inset-0 bg-white/30 mix-blend-overlay"></div>
    </div>
  );
}
